import type {BulkUpdateSummary} from 'api/types';
import type {TableConfiguration} from 'schema/table/types';
import {defaultTableConfig} from 'schema/table/configuration/defaultTableConfig';

export const bulkUpdateSummaryTableConfig: TableConfiguration<BulkUpdateSummary> =
  {
    ...defaultTableConfig,
    disableSorting: true,
    partValueRenderers: {},
  };
